var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "72C53685-950F-40D1-8B02-10D9FF39518F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Richr-Money",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ConnectBankAccount_ConnectedAccount_PopUp",
    transform: "translate(-146.000000, -251.000000)",
    fill: "#A30000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(20.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(59.000000, 132.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(67.000000, 109.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5813664,16.5488199 L11.0325466,12 L15.5813664,7.45118015 C16.1395445,6.89300204 16.1395445,5.98766054 15.5813664,5.42948243 L14.5705176,4.41863358 C14.0123395,3.86045547 13.106998,3.86045547 12.5488199,4.41863358 L8,8.96745343 L3.45118015,4.41863358 C2.89300204,3.86045547 1.98766054,3.86045547 1.42948243,4.41863358 L0.418633577,5.42948243 C-0.139544526,5.98766054 -0.139544526,6.89300204 0.418633577,7.45118015 L4.96745343,12 L0.418633577,16.5488199 C-0.139544526,17.106998 -0.139544526,18.0123395 0.418633577,18.5705176 L1.42948243,19.5813664 C1.98766054,20.1395445 2.89300204,20.1395445 3.45118015,19.5813664 L8,15.0325466 L12.5488199,19.5813664 C13.106998,20.1395445 14.0123395,20.1395445 14.5705176,19.5813664 L15.5813664,18.5705176 C16.1395445,18.0123395 16.1395445,17.106998 15.5813664,16.5488199 Z",
    id: "Path"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.d7b01468975b1c8499c0af140c0c2889.svg";
export { ForwardRef as ReactComponent };